export const AUTH_API_KEY_CREATE_OWN = "AUTH_API_KEY_CREATE_OWN";
export const AUTH_API_KEY_DELETE_OWN = "AUTH_API_KEY_DELETE_OWN";
export const AUTH_API_KEY_EDIT_OWN = "AUTH_API_KEY_EDIT_OWN";
export const AUTH_API_KEY_VIEW_ALL = "AUTH_API_KEY_VIEW_ALL";
export const AUTH_API_KEY_VIEW_OWN = "AUTH_API_KEY_VIEW_OWN";
export const AUTH_ASSET_CREATE = "AUTH_ASSET_CREATE";
export const AUTH_ASSET_DELETE = "AUTH_ASSET_DELETE";
export const AUTH_ASSET_EDIT = "AUTH_ASSET_EDIT";
export const AUTH_ASSET_GRADING = "AUTH_ASSET_GRADING";
export const AUTH_ASSET_INTEGRATION = "AUTH_ASSET_INTEGRATION";
export const AUTH_ASSET_VIEW = "AUTH_ASSET_VIEW";
export const AUTH_CUSTOM_ASSET_VIEW_CREATE = "AUTH_CUSTOM_ASSET_VIEW_CREATE";
export const AUTH_CUSTOM_ASSET_VIEW_DELETE = "AUTH_CUSTOM_ASSET_VIEW_DELETE";
export const AUTH_CUSTOM_ASSET_VIEW_EDIT = "AUTH_CUSTOM_ASSET_VIEW_EDIT";
export const AUTH_CUSTOM_ASSET_VIEW_VIEW = "AUTH_CUSTOM_ASSET_VIEW_VIEW";
export const AUTH_CUSTOM_REPORT_VIEW_CREATE_OWN = "AUTH_CUSTOM_REPORT_VIEW_CREATE_OWN";
export const AUTH_CUSTOM_REPORT_VIEW_CREATE_SHARED = "AUTH_CUSTOM_REPORT_VIEW_CREATE_SHARED";
export const AUTH_CUSTOM_REPORT_VIEW_DELETE_OWN = "AUTH_CUSTOM_REPORT_VIEW_DELETE_OWN";
export const AUTH_CUSTOM_REPORT_VIEW_DELETE_SHARED = "AUTH_CUSTOM_REPORT_VIEW_DELETE_SHARED";
export const AUTH_CUSTOM_REPORT_VIEW_EDIT_OWN = "AUTH_CUSTOM_REPORT_VIEW_EDIT_OWN";
export const AUTH_CUSTOM_REPORT_VIEW_EDIT_SHARED = "AUTH_CUSTOM_REPORT_VIEW_EDIT_SHARED";
export const AUTH_CUSTOM_REPORT_VIEW_VIEW = "AUTH_CUSTOM_REPORT_VIEW_VIEW";
export const AUTH_EMS_CREATE_ENTITLEMENT = "AUTH_EMS_CREATE_ENTITLEMENT";
export const AUTH_EMS_SYNCHRONIZE = "AUTH_EMS_SYNCHRONIZE";
export const AUTH_EMS_VIEW = "AUTH_EMS_VIEW";
export const AUTH_FILESHARE_CREATE = "AUTH_FILESHARE_CREATE";
export const AUTH_FILESHARE_DELETE = "AUTH_FILESHARE_DELETE";
export const AUTH_FILESHARE_EDIT = "AUTH_FILESHARE_EDIT";
export const AUTH_FILESHARE_VIEW = "AUTH_FILESHARE_VIEW";
export const AUTH_LICENSE_ASSIGN = "AUTH_LICENSE_ASSIGN";
export const AUTH_LICENSE_VIEW = "AUTH_LICENSE_VIEW";
export const AUTH_LICENSE_VIEW_OWN = "AUTH_LICENSE_VIEW_OWN";
export const AUTH_ASSET_MANIFEST_VIEW = "AUTH_ASSET_MANIFEST_VIEW";
export const AUTH_ASSET_MANIFEST_EDIT = "AUTH_ASSET_MANIFEST_EDIT";
export const AUTH_ASSET_VALUE_MANAGEMENT = "AUTH_ASSET_VALUE_MANAGEMENT";
export const AUTH_REPORT_IMPORT = "AUTH_REPORT_IMPORT";
export const AUTH_REPORT_TEMPLATE_CREATE = "AUTH_REPORT_TEMPLATE_CREATE";
export const AUTH_REPORT_TEMPLATE_DEFAULT = "AUTH_REPORT_TEMPLATE_DEFAULT";
export const AUTH_REPORT_TEMPLATE_DELETE = "AUTH_REPORT_TEMPLATE_DELETE";
export const AUTH_REPORT_TEMPLATE_EDIT = "AUTH_REPORT_TEMPLATE_EDIT";
export const AUTH_REPORT_TEMPLATE_VIEW = "AUTH_REPORT_TEMPLATE_VIEW";
export const AUTH_REPORT_VIEW = "AUTH_REPORT_VIEW";
export const AUTH_REPORT_EXPORT_ALL = "AUTH_REPORT_EXPORT_ALL";
export const AUTH_REPORT_DELETE = "AUTH_REPORT_DELETE";
export const AUTH_REPORT_EDIT = "AUTH_REPORT_EDIT";
export const AUTH_ROLE_CREATE = "AUTH_ROLE_CREATE";
export const AUTH_ROLE_DEFAULT = "AUTH_ROLE_DEFAULT";
export const AUTH_ROLE_DELETE = "AUTH_ROLE_DELETE";
export const AUTH_ROLE_EDIT = "AUTH_ROLE_EDIT";
export const AUTH_ROLE_VIEW = "AUTH_ROLE_VIEW";
export const AUTH_SIGNATURE_KEY_CREATE = "AUTH_SIGNATURE_KEY_CREATE";
export const AUTH_SIGNATURE_KEY_VIEW = "AUTH_SIGNATURE_KEY_VIEW";
export const AUTH_SIGNATURE_KEY_EDIT = "AUTH_SIGNATURE_KEY_EDIT";
export const AUTH_SIGNATURE_KEY_DELETE = "AUTH_SIGNATURE_KEY_DELETE";
export const AUTH_TENANT_ACCESS = "AUTH_TENANT_ACCESS";
export const AUTH_TENANT_CREATE = "AUTH_TENANT_CREATE";
export const AUTH_TENANT_DELETE = "AUTH_TENANT_DELETE";
export const AUTH_TENANT_EDIT = "AUTH_TENANT_EDIT";
export const AUTH_TENANT_SETTINGS = "AUTH_TENANT_SETTINGS";
export const AUTH_TENANT_VIEW = "AUTH_TENANT_VIEW";
export const AUTH_USER_CREATE = "AUTH_USER_CREATE";
export const AUTH_USER_DELETE = "AUTH_USER_DELETE";
export const AUTH_USER_EDIT = "AUTH_USER_EDIT";
export const AUTH_USER_VIEW = "AUTH_USER_VIEW";
export const AUTH_USER_GROUP_CREATE = "AUTH_USER_GROUP_CREATE";
export const AUTH_USER_GROUP_DELETE = "AUTH_USER_GROUP_DELETE";
export const AUTH_USER_GROUP_EDIT = "AUTH_USER_GROUP_EDIT";
export const AUTH_USER_GROUP_VIEW = "AUTH_USER_GROUP_VIEW";
export const AUTH_WORKFLOW_CREATE = "AUTH_WORKFLOW_CREATE";
export const AUTH_WORKFLOW_DEFAULT = "AUTH_WORKFLOW_DEFAULT";
export const AUTH_WORKFLOW_ENABLE = "AUTH_WORKFLOW_ENABLE";
export const AUTH_WORKFLOW_LAUNCH = "AUTH_WORKFLOW_LAUNCH";
export const AUTH_WORKFLOW_DELETE = "AUTH_WORKFLOW_DELETE";
export const AUTH_WORKFLOW_EDIT = "AUTH_WORKFLOW_EDIT";
export const AUTH_WORKFLOW_VIEW = "AUTH_WORKFLOW_VIEW";
export const AUTH_WORKFLOW_SCHEDULE = "AUTH_WORKFLOW_SCHEDULE";
export const AUTH_WORKFLOW_SECURED = "AUTH_WORKFLOW_SECURED";
export const AUTH_WORKFLOW_TEMPLATE_CREATE = "AUTH_WORKFLOW_TEMPLATE_CREATE";
export const AUTH_WORKFLOW_TEMPLATE_VIEW = "AUTH_WORKFLOW_TEMPLATE_VIEW";
export const AUTH_WORKFLOW_TEMPLATE_EDIT = "AUTH_WORKFLOW_TEMPLATE_EDIT";
export const AUTH_WORKFLOW_TEMPLATE_DELETE = "AUTH_WORKFLOW_TEMPLATE_DELETE";
export const AUTH_WORKFLOW_TEMPLATE_EXPORT = "AUTH_WORKFLOW_TEMPLATE_EXPORT";
export const AUTH_WORKFLOW_TEMPLATE_PUBLISH = "AUTH_WORKFLOW_TEMPLATE_PUBLISH";
export const AUTH_WORKFLOW_TEMPLATE_SCHEDULE = "AUTH_WORKFLOW_TEMPLATE_SCHEDULE";
export const AUTH_WORKFLOW_TEMPLATE_SECURED = "AUTH_WORKFLOW_TEMPLATE_SECURED";
export const AUTH_WORKFLOW_TEMPLATE_MANAGEMENT_VIEW = "AUTH_WORKFLOW_TEMPLATE_MANAGEMENT_VIEW";
export const AUTH_WORKFLOW_TEMPLATE_SAVE = "AUTH_WORKFLOW_TEMPLATE_SAVE";
export const AUTH_LICENSE_CONSUME = "AUTH_LICENSE_CONSUME";
export const AUTH_LICENSE_HISTORY_VIEW_OWN = "AUTH_LICENSE_HISTORY_VIEW_OWN";
export const AUTH_LICENSE_HISTORY_VIEW_ALL = "AUTH_LICENSE_HISTORY_VIEW_ALL";
export const AUTH_LICENSE_POOL_CREATE = "AUTH_LICENSE_POOL_CREATE";
export const AUTH_LICENSE_POOL_EDIT = "AUTH_LICENSE_POOL_EDIT";
export const AUTH_LICENSE_POOL_VIEW = "AUTH_LICENSE_POOL_VIEW";
export const AUTH_LICENSE_POOL_DELETE = "AUTH_LICENSE_POOL_DELETE";
export const AUTH_LICENSE_KEY_MANAGEMENT = "AUTH_LICENSE_KEY_MANAGEMENT";
export const AUTH_SSO_CONFIGURE = "AUTH_SSO_CONFIGURE";
export const AUTH_LICENSE_ALERT = "AUTH_LICENSE_ALERT";
export const AUTH_MC_CREATE = "AUTH_MC_CREATE";
export const AUTH_MC_VIEW = "AUTH_MC_VIEW";
export const AUTH_MC_EDIT = "AUTH_MC_EDIT";
export const AUTH_MC_UNREGISTER = "AUTH_MC_UNREGISTER";
export const AUTH_AUDIT_LOG_DELETE = "AUTH_AUDIT_LOG_DELETE";
export const AUTH_AUDIT_LOG_VIEW = "AUTH_AUDIT_LOG_VIEW";
export const AUTH_RENDER_RULE_MANAGE = "AUTH_RENDER_RULE_MANAGE";
export const AUTH_AI_ASSISTANT = "AUTH_AI_ASSISTANT";
